/* istanbul ignore file - better tested visually */

import MUIAutocomplete, { AutocompleteProps as MUIAutocompleteProps } from '@mui/material/Autocomplete';
import { ChipTypeMap } from '@mui/material/Chip';
import MUIInput from '@mui/material/TextField';
import { classNames } from '@partful/shared/lib/classNames';
import { InputProps } from '../Input';
import styles from './Autocomplete.module.scss';

type AutocompleteProps<
  Value,
  Multiple extends boolean | undefined,
  DisableClearable extends boolean | undefined,
  FreeSolo extends boolean | undefined,
  ChipComponent extends React.ElementType = ChipTypeMap['defaultComponent']
> = Omit<MUIAutocompleteProps<Value, Multiple, DisableClearable, FreeSolo, ChipComponent>, 'renderInput'> &
  Pick<InputProps, 'placeholder' | 'size'> & { error?: boolean };

/**
 * An autocomplete component that allows a user to type in a term and select
 * from a predefined list of options. Options can be static or asynchronously
 * loaded.
 */
export function Autocomplete<
  Value,
  Multiple extends boolean | undefined,
  DisableClearable extends boolean | undefined,
  FreeSolo extends boolean | undefined,
  ChipComponent extends React.ElementType = ChipTypeMap['defaultComponent']
>({
  className,
  placeholder,
  size = 'medium',
  disabled,
  error,
  ...props
}: AutocompleteProps<Value, Multiple, DisableClearable, FreeSolo, ChipComponent>) {
  return (
    <MUIAutocomplete
      className={classNames(styles.base, styles[size], className)}
      disabled={disabled}
      renderInput={(params) => (
        <MUIInput {...params} variant="outlined" placeholder={placeholder} disabled={disabled} error={error} />
      )}
      {...props}
    />
  );
}
